/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Senddate_Placeholder3Inputs */

const en_coinvestments_draftemail_senddate_placeholder3 = /** @type {(inputs: Coinvestments_Draftemail_Senddate_Placeholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date`)
};

/**
* | output |
* | --- |
* | "Pick a date" |
*
* @param {Coinvestments_Draftemail_Senddate_Placeholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_senddate_placeholder3 = /** @type {((inputs?: Coinvestments_Draftemail_Senddate_Placeholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Senddate_Placeholder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_senddate_placeholder3(inputs)
});
export { coinvestments_draftemail_senddate_placeholder3 as "coInvestments_draftEmail_sendDate_placeholder" }